export default [
  {
    shortCode: "2564",
    keyword: "Test1",
    subkeywords: "1q2we4",
    mobile: "8785242575",
    received: "abc",
    reply: "test",
  },
  {
    shortCode: "2547",
    keyword: "Test2",
    subkeywords: "1q2we4",
    mobile: "8785242575",
    received: "abc",
    reply: "test",
  },
];
